import { fetchServer } from "@/features/utils/fetch";
import type { CheckAuthorizationResponse } from "../types";

export class AutorisationApiClient {
  static async saveRequestAccount(identityUuid: string): Promise<CheckAuthorizationResponse> {
    const response = await fetchServer(`/user/save_request_account`, {
      method: "POST",
      reloadOn401: false,
      body: { identityUuid }
    });

    if (!response.ok) throw new Error();
    return await response.json();
  }
}
